import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';

@Pipe({
  name: 'safeEmailHtml',
})
export class SafeEmailHtmlPipe implements PipeTransform {
  sanitizer = inject(DomSanitizer);
  transform(value: string | null): SafeHtml {
    if (!value) {
      return '';
    }

    const sanitized = DOMPurify.sanitize(value, {
      ALLOWED_TAGS: [
        'p',
        'i',
        'u',
        'b',
        'strong',
        'span',
        'ul',
        'ol',
        'li',
        'a',
        'br',
        'img',
        'table',
        'thead',
        'tbody',
        'th',
        'td',
        'tr',
        'div',
      ],
      ALLOWED_ATTR: ['style', 'href', 'src', 'border'],
    });

    // Need to discus this first
    // return this.sanitizer.bypassSecurityTrustHtml(sanitized);
    return sanitized;
  }
}
